import { render } from "./OurFeatures.vue?vue&type=template&id=b561d348"
import script from "./OurFeatures.vue?vue&type=script&lang=js"
export * from "./OurFeatures.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__